import routerWithSidebar from "./routerWithSidebar";
import { PATH_DAILY, PATH_DAILY_WRITE } from "@/constants/URL";

export default {
  path: PATH_DAILY,
  component: () =>
    import(/* webpackChunkName: "SidebarLayout" */ "@/layout/SidebarLayout/index.vue"),
  children: [
    {
      path: PATH_DAILY,
      name: "daily",
      components: routerWithSidebar(() =>
        import(/* webpackChunkName: "role" */ "@/views/daily/index.vue")
      ),
      children: [
        {
          path: PATH_DAILY_WRITE,
          name: "writeDaily",
          components: routerWithSidebar(() =>
            import(/* webpackChunkName: "role" */ "@/views/daily/writeDaily.vue")
          )
        },
        {
          path: PATH_DAILY,
          name: "daily",
          components: routerWithSidebar(() =>
            import(/* webpackChunkName: "role" */ "@/views/daily/readDaily.vue")
          )
        }
      ]
    }
  ]
};
